import { isFiniteNumber } from '@/utils/validators/common';

/**
 * 將輸入值轉化成數字，否則回傳 null
 * @param n - 要轉換的值
 * @returns 轉換後的數字或 null
 */
export const toFiniteNumberOrNull = (n: any) => {
  return isFiniteNumber(n) ? Number(n) : null;
};

/**
 * 將數字轉成千分位格式，小數四捨五入最多取至第 2 位
 * @param n - 要格式化的數字
 * @returns 格式化後的字串，如 "10,000" 或 null
 * @example toGroupingNumber(10000) // "10,000"
 * @example toGroupingNumber(9.991) // "9.99"
 */
export function toGroupingNumber (n: number | string) {
  const num = toFiniteNumberOrNull(n);
  if (num === null) { return null; }

  const nf = new Intl.NumberFormat('en', { maximumFractionDigits: 2 });
  return nf.format(num);
}

/**
 * 回傳整數的商和餘數，用於時間計算
 * 不處理 non finite numbers 跟 IEEE-754 誤差
 * @param x - 被除數
 * @param y - 除數
 * @returns [商, 餘數]
 */
export const divmod = (x: number, y: number) => {
  const q = Math.floor(x / y);
  const r = x - q * y;
  return [q, r];
};
